import { IModuleProps } from '../../core/utils/modules';
import { JaegerMaterialSpecificationField, JAEGER_FIELD_NAMES } from './components/JaegerMaterialSpecificationField';
import React from 'react';

// Create wrapper components for each of the four material specification fields
// Each field uses the combined search term: "{norm} {guete} {oberflaeche} {mass}"
const JaegerNormField = (props: any) => (
    <JaegerMaterialSpecificationField {...props} targetFieldName={JAEGER_FIELD_NAMES.NORM} />
);
const JaegerOberflaecheField = (props: any) => (
    <JaegerMaterialSpecificationField {...props} targetFieldName={JAEGER_FIELD_NAMES.OBERFLAECHE} />
);
const JaegerGueteField = (props: any) => (
    <JaegerMaterialSpecificationField {...props} targetFieldName={JAEGER_FIELD_NAMES.GUETE} />
);
const JaegerMassField = (props: any) => (
    <JaegerMaterialSpecificationField {...props} targetFieldName={JAEGER_FIELD_NAMES.MASS} />
);

export default {
    name: 'jaeger',
    components: {
        Field: [
            {
                condition: ({ fieldName }) => fieldName === JAEGER_FIELD_NAMES.NORM,
                component: JaegerNormField,
            },
            {
                condition: ({ fieldName }) => fieldName === JAEGER_FIELD_NAMES.OBERFLAECHE,
                component: JaegerOberflaecheField,
            },
            {
                condition: ({ fieldName }) => fieldName === JAEGER_FIELD_NAMES.GUETE,
                component: JaegerGueteField,
            },
            {
                condition: ({ fieldName }) => fieldName === JAEGER_FIELD_NAMES.MASS,
                component: JaegerMassField,
            },
        ],
    },
} as IModuleProps;
